import { Radio } from 'antd';
import * as React from 'react';

interface RadioFieldProps {
  showAsButtons?: boolean;
  buttonStyle?: any;
  options?: any[];
  onChanged?: (any) => any;
}

const RadioField: React.FC<RadioFieldProps> = React.forwardRef(
  ({ showAsButtons = false, buttonStyle = 'solid', options = [], ...props }, ref) => {
    // const [OPTIONS, setOPTIONS] = React.useState(options)

    // React.useEffect(() => {
    // 	if (options && options.length) {
    // 		const _options = defaultSelectFormatter(options)

    // 		setOPTIONS(_options)

    // 	}
    // }, [options])

    const RadioComp = showAsButtons ? Radio.Button : Radio;

    return (
      <Radio.Group {...props} buttonStyle={buttonStyle}>
        {options.map((option) => (
          <RadioComp key={option?.value ?? option.key} value={option?.value ?? option.key}>
            {option.label}
          </RadioComp>
        ))}
      </Radio.Group>
    );
  }
);

export default RadioField;
